<template>
    <article class="story__body" data-flex="row">

        <StoryImage
            :src="src(resource.media)"
            priority="high"
        />

        <div data-v-animate :class="['has-overflow', resource.slug]">

            <StoryHead 
                :title="resource.title"
                :subtitle="resource.job"
            />

            <template v-for="(paragraph, i) in resource.text">
                <div v-if="(paragraph instanceof Object)" :key="`paragraph-${i}`">

                    <ul
                        v-if="paragraph.type === 'bullet-list'"
                        :class="[paragraph.type]"
                    >
                        <li v-for="(item, i) in paragraph.list" :key="i">
                            <div>{{ item }}</div>
                        </li>
                    </ul>

                    <ol
                        v-if="paragraph.type === 'arrow-list'"
                        :class="[paragraph.type]"
                    >
                        <li v-for="(item, i) in paragraph.list" :key="i">
                            <arrow-button
                                tag="span"
                                type="bottom"
                                style="cursor:default"
                                class="screen"
                            />
                            <div>{{ item }}</div>
                        </li>
                    </ol>

                    <link-button
                        v-else-if="paragraph.type === 'button-purple'" 
                        :text="paragraph.text"
                        :href="paragraph.link"
                    />

                    <h2 
                        v-else-if="paragraph.type === 'title'" 
                        class="subtitle--header subtitle--inner is-purple"
                        v-html="paragraph.text" 
                    />

                    <h3 
                        v-else-if="paragraph.type === 'subtitle'" 
                        class="subtitle--medium subtitle--inner" :style="{
                            color: 'currentColor'
                        }"
                        v-html="paragraph.text" 
                    />

                    <a 
                        v-else 
                        :href="paragraph.link" 
                        style="display: block;margin-top: .75rem"
                        class="inner-link" 
                        v-text="paragraph.text" 
                        target="_blank"
                    />

                </div>
                <p v-else v-html="paragraph" :key="`paragraph-${i}`"></p>
            </template>

        </div>

    </article>
</template>

<script>
import { mapGetters } from 'vuex'
import { teamImage } from '@/mixins/images'
import StoryHead from '../Story/StoryHead'
import StoryImage from '../Story/StoryImage'

export default {
    name: 'TeamMember',
    metaInfo() {
        const { title } = this.resource
        return {
            title: `${title.join(' ')}`,
        }
    },
    props: ['slug', 'photo'],
    components: { 
        StoryHead,
        StoryImage,
    },
    mixins: [ teamImage ],
    methods: {
        click(url) {
            let handler = window.open(url, '_blank')
            handler.focus()
        },
        src(media) {
            // const campusPathImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
            // return !media.includes('cpa-support') 
            //     ? this.memberSrc(media)
            //     : campusPathImage
            return this.memberSrc(media)
        }
    },
    computed: {
        resource() {
            const x = this.campusResources.findIndex(
                member => member.slug === this.slug
            )
            return this.campusResources[x]
        },
        ...mapGetters(['campusResources'])
    },
}
</script>
